const NavigationData = [
  {
    title: "Super Deals",
    highlight: true,
    href: "#",
    content: null,
  },
  {
    title: "Dufte",
    highlight: false,
    href: "#",
    content: {
      spot: {
        imageUrlDesktop: "/static/newshop/img2.png",
        imageUrlMobile: "/static/newshop/img2.png",
        smallHeadline: "Travel exclusives – fås kun i TAX FREE",
      },
      nav: [
        [
          {
            type: "category",
            title: "Bestsellers",
            href: "#",
            links: [],
          },
          {
            type: "category",
            title: "Everyday Low Prices",
            href: "#",
            links: [],
          },
          {
            type: "spacing",
            links: [],
          },
          {
            type: "category",
            title: "Nyheder",
            href: "#",
            links: [
              {
                title: "Damedufte",
                href: "#",
              },
              {
                title: "Herredufte",
                href: "#",
              },
            ],
          },
        ],
        [
          {
            type: "category",
            title: "Dame",
            href: "#",
            links: [
              {
                title: "Parfume",
                href: "#",
              },
              {
                title: "Deodoranter",
                href: "#",
              },
              {
                title: "Sæt & Gaveæsker",
                href: "#",
              },
            ],
          },
        ],
        [
          {
            type: "category",
            title: "Herre",
            href: "#",
            links: [
              {
                title: "Parfume",
                href: "#",
              },
              {
                title: "Aftershave",
                href: "#",
              },
              {
                title: "Deodoranter",
                href: "#",
              },
              {
                title: "Sæt & Gaveæsker",
                href: "#",
              },
            ],
          },
        ],
        [
          {
            type: "category",
            title: "Andre leder efter",
            href: "#",
            links: [
              {
                title: "Dior",
                href: "#",
              },
              {
                title: "Giorgio Armani",
                href: "#",
              },
              {
                title: "Gaveæsker",
                href: "#",
              },
              {
                title: "Rejsestørrelser",
                href: "#",
              },
              {
                title: "Lancôme",
                href: "#",
              },
              {
                title: "Dolce Gabbana",
                href: "#",
              },
            ],
          },
        ],
      ],
    },
  },
  {
    title: "Skønhed",
    highlight: false,
    href: "#",
    content: {
      spot: {
        imageUrlDesktop: "/static/newshop/img2.png",
        imageUrlMobile: "/static/newshop/img2.png",
        smallHeadline: "Lorem ipsum",
      },
      nav: [
        [
          {
            type: "category",
            title: "Bestsellers",
            href: "#",
            links: [],
          },
          {
            type: "category",
            title: "Everyday Low Prices",
            href: "#",
            links: [],
          },
          {
            type: "spacing",
            links: [],
          },
          {
            type: "category",
            title: "Nyheder",
            href: "#",
            links: [
              {
                title: "Hudpleje",
                href: "#",
              },
              {
                title: "Makeup",
                href: "#",
              },
              {
                title: "Hårpleje",
                href: "#",
              },
            ],
          },
        ],
        [
          {
            type: "category",
            title: "Hudpleje",
            href: "#",
            links: [
              {
                title: "Ansigtspleje",
                href: "#",
              },
              {
                title: "Håndpleje",
                href: "#",
              },
              {
                title: "Kropspleje",
                href: "#",
              },
              {
                title: "Solpleje",
                href: "#",
              },
              {
                title: "Barbering",
                href: "#",
              },
            ],
          },
          {
            type: "spacing",
          },
          {
            type: "category",
            title: "Hårpleje",
            href: "#",
            links: [
              {
                title: "Shampoo & Balsam",
                href: "#",
              },
              {
                title: "Hårkur- og olie",
                href: "#",
              },
              {
                title: "Hårstyling & voks",
                href: "#",
              },
              {
                title: "Skægpleje",
                href: "#",
              },
            ],
          },
        ],
        [
          {
            type: "category",
            title: "Makeup",
            href: "#",
            links: [
              {
                title: "Ansigt",
                href: "#",
              },
              {
                title: "Øjne",
                href: "#",
              },
              {
                title: "Bryn",
                href: "#",
              },
              {
                title: "Læber",
                href: "#",
              },
              {
                title: "Negle",
                href: "#",
              },
              {
                title: "Makeup-tilbehør",
                href: "#",
              },
            ],
          },
        ],
        [
          {
            type: "category",
            title: "Populære kategorier",
            href: "#",
            links: [
              {
                title: "Dagcreme",
                href: "#",
              },
              {
                title: "Bodylotion",
                href: "#",
              },
              {
                title: "Ansigtsrens",
                href: "#",
              },
              {
                title: "Mascara",
                href: "#",
              },
              {
                title: "Ansigtsmasker",
                href: "#",
              },
              {
                title: "Foundation",
                href: "#",
              },
              {
                title: "Neglelak",
                href: "#",
              },
              {
                title: "Kropsolier",
                href: "#",
              },
            ],
          },
        ],
      ],
    },
  },
  {
    title: "Drikkevarer",
    highlight: false,
    href: "#",
    content: {
      spot: {
        imageUrlDesktop: "/static/newshop/img2.png",
        imageUrlMobile: "/static/newshop/img2.png",
        smallHeadline: "Travel exclusives – fås kun i TAX FREE",
      },
      nav: [
        [
          {
            type: "category",
            title: "Spiritus",
            href: "#",
            links: [
              {
                title: "Whiskey",
                href: "#",
              },
              {
                title: "Gin",
                href: "#",
              },
              {
                title: "Likør",
                href: "#",
              },
              {
                title: "Cognac",
                href: "#",
              },
              {
                title: "Vodka",
                href: "#",
              },
              {
                title: "Tequila",
                href: "#",
              },
              {
                title: "Akvavit",
                href: "#",
              },
              {
                title: "Bitter & Apperitif",
                href: "#",
              },
              {
                title: "Brandy",
                href: "#",
              },
            ],
          },
        ],
        [
          {
            type: "category",
            title: "Vin & Øl",
            href: "#",
            links: [
              {
                title: "Rødvin",
                href: "#",
              },
              {
                title: "Hvidvin",
                href: "#",
              },
              {
                title: "Rosé",
                href: "#",
              },
              {
                title: "Champagne",
                href: "#",
              },
              {
                title: "Mousserende vin",
                href: "#",
              },
              {
                title: "Øl",
                href: "#",
              },
              {
                title: "Cider",
                href: "#",
              },
            ],
          },
          {
            type: "spacing",
            links: [],
          },
          {
            type: "category",
            title: "Kaffe og Te",
            href: "#",
            links: [],
          },
        ],
        [
          {
            type: "category",
            title: "Populære mærker",
            href: "#",
            links: [
              {
                title: "Hennesy",
                href: "#",
              },
              {
                title: "Möet & Chandon",
                href: "#",
              },
              {
                title: "Bottega",
                href: "#",
              },
              {
                title: "Jack Daniel's",
                href: "#",
              },
              {
                title: "Braastad",
                href: "#",
              },
              {
                title: "Chivas",
                href: "#",
              },
              {
                title: "Tommasi",
                href: "#",
              },
              {
                title: "Mikkeller",
                href: "#",
              },
              {
                title: "Jacobson",
                href: "#",
              },
            ],
          },
        ],
      ],
    },
  },
  {
    title: "Slik & Snacks",
    highlight: false,
    href: "#",
    content: null,
  },
  {
    title: "Tobak",
    highlight: false,
    href: "#",
    content: null,
  },
  {
    title: "Gaver & livsstil",
    highlight: false,
    href: "#",
    content: null,
  },
  {
    title: "Mærker",
    highlight: false,
    href: "#",
    content: null,
  },
]

export default NavigationData
